import { connect } from 'react-redux';
import { updateAlert, getAlert } from 'src/actions/alerts';
import { showAlert } from 'src/actions/globalAlert';
import { isAccountUiOptionSet } from 'src/helpers/conditions/account';

function withAlertsUpdate(WrappedComponent) {
  const mapDispatchToProps = { updateAlert, showUIAlert: showAlert, getAlert };

  const mapStateToProps = (state, props) => ({
    id: props.match.params.id,
    getError: state.alerts.getError,
    getLoading: state.alerts.getPending,
    loading: state.alerts.updatePending,
    isAlertsV2Enable: isAccountUiOptionSet('new_alerts_enabled')(state)
  });

  return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
}

export default withAlertsUpdate;
